import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CommonUtilityServiceService {
  constructor() {}

  stateMap = new Map<string, string>([
    ['ALABAMA', 'Alabama'],
    ['ALASKA', 'Alaska'],
    ['ARIZONA', 'Arizona'],
    ['ARKANSAS', 'Arkansas'],
    ['CALIFORNIA', 'California'],
    ['COLORADO', 'Colorado'],
    ['CONNECTICUT', 'Connecticut'],
    ['DELAWARE', 'Delaware'],
    ['DISTRICT_OF_COLUMBIA', 'District of Columbia'],
    ['FLORIDA', 'Florida'],
    ['GEORGIA', 'Georgia'],
    ['HAWAII', 'Hawaii'],
    ['IDAHO', 'Idaho'],
    ['ILLINOIS', 'Illinois'],
    ['INDIANA', 'Indiana'],
    ['IOWA', 'Iowa'],
    ['KANSAS', 'Kansas'],
    ['KENTUCKY', 'Kentucky'],
    ['LOUISIANA', 'Louisiana'],
    ['MAINE', 'Maine'],
    ['MARYLAND', 'Maryland'],
    ['MASSACHUSETTS', 'Massachusetts'],
    ['MICHIGAN', 'Michigan'],
    ['MINNESOTA', 'Minnesota'],
    ['MISSISSIPPI', 'Mississippi'],
    ['MISSOURI', 'Missouri'],
    ['MONTANA', 'Montana'],
    ['NEBRASKA', 'Nebraska'],
    ['NEVADA', 'Nevada'],
    ['NEW_HAMPSHIRE', 'New Hampshire'],
    ['NEW_JERSEY', 'New Jersey'],
    ['NEW_MEXICO', 'New Mexico'],
    ['NEW_YORK', 'New York'],
    ['NORTH_CAROLINA', 'North Carolina'],
    ['NORTH_DAKOTA', 'North Dakota'],
    ['OHIO', 'Ohio'],
    ['OKLAHOMA', 'Oklahoma'],
    ['OREGON', 'Oregon'],
    ['PENNSYLVANIA', 'Pennsylvania'],
    ['RHODE_ISLAND', 'Rhode Island'],
    ['SOUTH_CAROLINA', 'South Carolina'],
    ['SOUTH_DAKOTA', 'South Dakota'],
    ['TENNESSEE', 'Tennessee'],
    ['TEXAS', 'Texas'],
    ['UTAH', 'Utah'],
    ['VERMONT', 'Vermont'],
    ['VIRGINIA', 'Virginia'],
    ['WASHINGTON', 'Washington'],
    ['WEST_VIRGINIA', 'West Virginia'],
    ['WISCONSIN', 'Wisconsin'],
    ['WYOMING', 'Wyoming'],
    ['PUERTO_RICO', 'Puerto Rico'],
    ['GUAM', 'Guam'],
    ['AMERICAN_SAMOA', 'American Samoa'],
    ['VIRGIN_ISLANDS', 'United States Virgin Islands'],
    ['NORTHERN_MARIANA_ISLANDS', 'Northern Mariana Islands'],
  ]);

  formatAddress(data: any) {
    let streetAddress: string = '';
    let cityStateZip: string = '';
    if (data.site.parcels) {
      let addressDetails = data.site.parcels[0];
      if (addressDetails) {
        if (addressDetails.street) {
          streetAddress = addressDetails.street;
          streetAddress = streetAddress
            .toLowerCase()
            .split(' ')
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
        }

        if (addressDetails.city) {
          cityStateZip = cityStateZip + addressDetails.city + ', ';
        }
        if (addressDetails.state) {
          cityStateZip =
            cityStateZip + this.decodeUsState(addressDetails.state) + ', ';
        }
        if (addressDetails.zipcode) {
          cityStateZip = cityStateZip + addressDetails.zipcode;
        }
        cityStateZip = cityStateZip
          .toLowerCase()
          .split(' ')
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ');
      }
    }
    return { streetAddress: streetAddress, cityStateZip: cityStateZip };
  }

  formatTableAFromArray(tableAItems: any[]) {
    // Three elements, matching formatTableA below - a two-element answer here
    // would make index 2 undefined for a caller that reads it.
    if (!tableAItems) return ['', '', ''];
    const containsItem21 = tableAItems.some(
      (item: any) => item.itemName === '21'
    );
    return this.formatTableA({ site: { tableA: tableAItems } }, containsItem21);
  }

  /**
   * Returns `[item20Or21Text, tableAItemList, item20Or21Label]`.
   *
   * The third element is additive on purpose - index 0 and index 1 keep the
   * meanings every existing caller already reads, so nothing had to change to
   * gain it. It names WHICH item the free text came from ("Item 20" on a survey
   * predating Feb 2026, "Item 21" after), which is what lets a screen label the
   * text rather than printing it bare; the item number is decided here, so
   * deriving it again at each render site would be the same rule in three
   * places.
   */
  formatTableA(data: any, containsItem21: boolean) {
    let tableAItemName: string = '';
    let item20OrItem21textValue: string = '';
    let item20OrItem21Label: string = '';
    data.site.tableA?.forEach((element: any) => {
      if (element.checked) {
        tableAItemName += ', ' + element.itemName;
        if (!containsItem21 && element.itemName?.trim() === '20') {
          item20OrItem21textValue = element.textFieldValue;
          // Label only alongside actual text - a checked item with a blank field
          // must not leave a bare "Item 20:" lead-in on screen.
          item20OrItem21Label = element.textFieldValue ? 'Item 20' : '';
        } else if (containsItem21 && element.itemName?.trim() === '21') {
          item20OrItem21textValue = element.textFieldValue;
          item20OrItem21Label = element.textFieldValue ? 'Item 21' : '';
        } else if (element.value && element.itemName?.trim() === '19') {
          tableAItemName += ` ($${
            element.value === 1000000 ? '1M' : element.value
          } E&O)`;
        }
      }
    });
    return [
      item20OrItem21textValue,
      tableAItemName.replace(',', ''),
      item20OrItem21Label,
    ];
  }

  determineMapCenter(parcels: any) {
    if (parcels && parcels[0] && parcels[0].center) {
      return { lat: parcels[0].center[0], lng: parcels[0].center[1] };
    } else {
      // center of US
      return { lat: 39.8283, lng: -98.5795 };
    }
  }

  determineMapZoomLevel(acreage: number) {
    let zoom = 14;
    if (acreage < 1) {
      zoom = 18;
    } else if (acreage <= 100) {
      zoom = 17;
    } else if (acreage > 100) {
      zoom = 16;
    } else if (acreage > 200) {
      zoom = 15;
    }
    return zoom;
  }

  detemineMapBounderies(siteDetail: any): google.maps.LatLngLiteral[] {
    let boundaries: google.maps.LatLngLiteral[] = [];
    siteDetail.site.parcels.forEach((parcel: any) => {
      let currentSiteBoundaries = parcel.boundary.map((coordindates: any) => ({
        lat: coordindates[0],
        lng: coordindates[1],
      }));
      boundaries.push(currentSiteBoundaries);
    });
    return boundaries;
  }

  determineDocumentTypeByProposalStatus(status: string): string {
    switch (status) {
      case 'INVITATION':
      case 'PROPOSAL':
      case 'SUBMITTED':
      case 'OFFERED':
      case 'COUNTERED':
      case 'RE_OFFERED':
        return 'PROPOSAL';
      case 'ACTIVE':
        return 'DELIVERABLE';
      case 'REVISION_REQUESTED':
      case 'REVIEW_PENDING':
      case 'REVISION_PENDING':
        return 'REVISION';
      default:
        return '';
    }
  }

  decodeUsState(state: any): string {
    return this.stateMap.get(state) || '';
  }

  /**
   * Humanizes an unmapped enum-style value (e.g. `DISTRICT_OF_COLUMBIA`) into a
   * readable label: split on `_`, title-case each word, lower-case mid-phrase
   * connectors (of/and/the). Use as the fallback when `stateMap` has no entry so
   * zone/state labels never render the raw enum. Shared by the Users list and
   * the User Location Map so both read identically.
   */
  humanizeEnum(raw: string): string {
    const small = new Set(['of', 'and', 'the']);
    return (raw ?? '')
      .split('_')
      .filter((word) => word.length > 0)
      .map((word, i) => {
        const lower = word.toLowerCase();
        if (i > 0 && small.has(lower)) {
          return lower;
        }
        return lower.charAt(0).toUpperCase() + lower.slice(1);
      })
      .join(' ');
  }
}
